const wowApp = require('angular').module('wowApp.common');
wowApp.filter('bwsTitleCase', [require('./bws-title-case')]);
wowApp.filter('bwsCents', [require('./bws-cents')]);
wowApp.filter('bwsDollars', [require('./bws-dollars')]);
wowApp.filter('wowCurrency', ['currencyFilter', require('./wow-currency')]);
wowApp.filter('wowCurrencyFull', ['currencyFilter', require('./wow-currencyfull')]);
wowApp.filter('sanitize', ['$sce', require('./wow-sanitize')]);
wowApp.filter('hyphenate', [require('./wow-hyphenate-name')]);
wowApp.filter('olyOrdinal', [require('./oly-ordinal')]);
wowApp.filter('usernamelimiter', [require('./wow-username-limiter')]);
wowApp.filter('highlight', ['$sce', require('./oly-highlight')]);
wowApp.filter('wowNutrition', [require('./wow-nutrition-filter')]);
wowApp.filter('paragraphize', [require('./paragraphize')]);
wowApp.filter('sentenceCase', [require('./oly-apply-sentence-case')]);
wowApp.filter('htmlToPlainText', [require('./wow-html-to-plain-text')]);
wowApp.filter('inArray', [require('./in-array')]);
wowApp.filter('timeTransformer', [require('./bws-24-12hr-time')]);
wowApp.filter('formatDate', [require('./wow-format-date')]);
wowApp.filter('bwsLinkHref', [require('./bws-link-href')]);
wowApp.filter('bwsLinkText', [require('./bws-link-text')]);


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/filters/index.js
 **/